/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DynamicPermission
 */
export interface DynamicPermission {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    title: string;
    /**
     * 
     */
    description: string;
    /**
     * 
     */
    category: string;
    /**
     * 
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the DynamicPermission interface.
 */
export function instanceOfDynamicPermission(value: object): value is DynamicPermission {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function DynamicPermissionFromJSON(json: any): DynamicPermission {
    return DynamicPermissionFromJSONTyped(json, false);
}

export function DynamicPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DynamicPermission {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'title': json['title'],
        'description': json['description'],
        'category': json['category'],
        'enabled': json['enabled'],
    };
}

export function DynamicPermissionToJSON(json: any): DynamicPermission {
    return DynamicPermissionToJSONTyped(json, false);
}

export function DynamicPermissionToJSONTyped(value?: DynamicPermission | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'title': value['title'],
        'description': value['description'],
        'category': value['category'],
        'enabled': value['enabled'],
    };
}

